import { FormattedMessage, defineMessages } from 'react-intl';

import { ShopItemType } from '@sorare/core/src/__generated__/globalTypes';
import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { CheckboxGroup } from '@sorare/core/src/atoms/inputs/CheckboxGroup';
import { glossary } from '@sorare/core/src/lib/glossary';
import type { FilterableType } from '@sorare/core/src/types/shopItems';
import { MERCHANDISE_TYPES } from '@sorare/core/src/types/shopItems';

import { getFilterableTypes } from './utils.ts';

const messages = defineMessages<FilterableType>({
  [ShopItemType.BACKGROUND]: {
    defaultMessage: 'Stadium',
  },
  [ShopItemType.ACHIEVEMENT_BADGE]: {
    defaultMessage: 'Achievement badge',
  },
  [ShopItemType.CLUB_BADGE]: {
    defaultMessage: 'Club badge',
  },
  [ShopItemType.EXTRA_SWAP]: {
    defaultMessage: 'Extra swap',
  },
  [ShopItemType.EXTRA_TEAMS_CAP]: {
    defaultMessage: 'Extra training team',
  },
  [ShopItemType.LEVEL_UP]: {
    defaultMessage: 'Level up',
  },
  [ShopItemType.APPEARANCE_BOOST]: {
    defaultMessage: 'Boost',
  },
  [ShopItemType.COMMON_CARD_SWAP]: {
    defaultMessage: 'Swap',
  },
  MERCHANDISE: {
    defaultMessage: 'Merchandise',
  },
});

type Props = {
  types: ShopItemType[];
  values: ShopItemType[];
  onChange: (v: ShopItemType[]) => void;
};

export const FilterBy = ({ types, values, onChange }: Props) => {
  const filterableTypes = getFilterableTypes(types);
  const filterableValues = getFilterableTypes(values);

  return (
    <FilterInDropdown buttonLabel={<FormattedMessage {...glossary.filterBy} />}>
      <CheckboxGroup<FilterableType>
        options={filterableTypes.map(type => ({
          value: type,
          label: <FormattedMessage {...messages[type]} />,
        }))}
        selectedValues={filterableValues}
        onChange={(newValues: FilterableType[]) => {
          const shopItemTypes = newValues.flatMap(type =>
            type === 'MERCHANDISE' ? MERCHANDISE_TYPES : [type]
          ) as ShopItemType[];

          onChange(shopItemTypes);
        }}
      />
    </FilterInDropdown>
  );
};
